import OrganizationInviteScreen from './RequiredCardUpdateScreen';

export default OrganizationInviteScreen;
